import CryptoJS from 'crypto-js';

// 签名密钥（与小程序端保持一致）
const SIGN_SECRET = 'MIISIjANCgkqhkiG9w0BADEF6AOCAQQAMII5CgKC7AEAx0EX';

// 生成指定长度的随机字符串（大小写字母 + 数字）
export function randomStr(len) {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let s = '';
    for (let i = 0; i < len; i++) {
        s += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return s;
}

/**
 * 生成接口签名请求头（纯函数）
 * 签名值 = SHA256(timestamp + nonce + signSecret)，输出小写 hex
 * @returns {{ 'X-Timestamp': string, 'X-Nonce': string, 'X-Sign': string }}
 */
export function generateSignHeaders() {
    const timestamp = Date.now().toString();
    const nonce = randomStr(16);
    const sign = CryptoJS.SHA256(timestamp + nonce + SIGN_SECRET).toString();
    return {
        'X-Timestamp': timestamp,
        'X-Nonce': nonce,
        'X-Sign': sign,
    };
}

// 后端签名校验类错误 → 前端友好提示（未命中则返回空，走原有业务错误提示）
const SIGN_ERROR_MESSAGES = [
    { match: ['请求已过期'], tip: '请检查电脑时间是否准确后重试' },
    { match: ['签名校验失败', '缺少签名参数'], tip: '网络异常，请稍后重试' },
    { match: ['请勿重复提交'], tip: '操作太频繁，请稍后再试' },
];

/**
 * 将后端签名校验错误信息映射为友好提示（纯函数）
 * @param {string} msg 后端返回的错误信息
 * @returns {string|null} 友好提示，非签名类错误返回 null
 */
export function mapSignErrorMsg(msg) {
    if (!msg) {
        return null;
    }
    const target = SIGN_ERROR_MESSAGES.find(item =>
        item.match.some(keyword => msg.includes(keyword))
    );
    return target ? target.tip : null;
}
